import React from "react";
import TableComponent from "./TableComponent";
import { formatCurrencyV2, formatDate, getKycChip } from "../utils/helpers";

export const transactionColumns = [
  {
    field: "transaction_timestamp",
    headerName: "Date",
    minWidth: 170,
    flex: 1,
    valueGetter: (params) =>
      params.row.transaction_timestamp ||
      params.row.transaction_settlement_time,
    valueFormatter: (params) => formatDate(params?.value),
  },
  {
    field: "transaction_id",
    headerName: "Transaction ID",
    minWidth: 170,
    flex: 1,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    minWidth: 300,
    renderCell: (params) => (
      <div
        style={{
          whiteSpace: "normal",
          wordWrap: "break-word",
          width: "100%",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "credit",
    headerName: "Deposit (Money In)",
    minWidth: 120,
    flex: 1,
    valueFormatter: (params) => formatCurrencyV2(params?.value),
  },
  {
    field: "debit",
    headerName: "Withdrawal (Money Out)",
    minWidth: 120,
    flex: 1,
    valueFormatter: (params) => formatCurrencyV2(params?.value),
  },

  {
    field: "balance_after",
    headerName: "Balance",
    minWidth: 120,
    flex: 1,
    valueFormatter: (params) => formatCurrencyV2(params?.value),
  },
  {
    field: "transaction_status",
    headerName: "Status",
    minWidth: 150,
    flex: 1,
    renderCell: (params) => getKycChip(params?.value),
  },
];

const TransactionTable = ({
  columns,
  extraColumns = [],
  sortModel = [{ field: "transaction_timestamp", sort: "desc" }],
  ...props
}) => {
  const tableColumns = columns || [...transactionColumns, ...extraColumns];
  return (
    <TableComponent
      columns={tableColumns}
      sortModel={sortModel}
      getRowHeight={() => "auto"}
      {...props}
    />
  );
};

export default TransactionTable;
